export default __webpack_public_path__ + "static/media/06.b5823cb2.jpg";